import React from 'react';
import { toast } from 'react-toastify';
import { serialize, unserialize } from 'php-serialize';
import { useParams } from 'react-router-dom';

import { showSwal } from '../../../constants/swalConfig';
import api from '../../../constants/api';
import SectionOne from '../../../components/fleetnexis/editquotation/SectionOne';
import QuotationServices from '../../../components/fleetnexis/quotation/QuotationServices';
//import EditSpare from '../../../components/fleetnexis/editquotation/EditSpare';
import SpareAdd from '../../../components/fleetnexis/quotation/SpareAdd';
import BreadCrumbs from '../../../layouts/breadcrumbs/BreadCrumbs';
import ActionButton from '../../../components/common/ActionButton';
import Text from '../../../components/common/Text';
import BackButton from '../../../components/common/BackButton';
import ComponentCard from '../../../components/ComponentCard';
import DataTable from '../../../components/common/DataTable';
import { useLocaleConfig } from '../../../context/AppContext';
import { buildPreferredDate } from '../../../constants/preferredDate';
import AppButton from '../../../components/common/AppButton';
import { isApiSuccess } from '../../../constants/apiResult';
import {
  firstPresent,
  formatVehicleType,
  isBlank,
  openBrandedPdf,
  signedInUserName,
} from '../../../components/fleetnexis/pdf/brandedPdf';
import buildQuotationPdf from './quotationPdf';

export default function Editquote() {
  const { id } = useParams();
  const {
    currencyCode,
    timezone,
    utcOffset,
    taxMode,
    taxLineItems,
    formatCurrency,
    getAmountWithTax,
  } = useLocaleConfig();
  const [quote, setQuotationData] = React.useState({
    phone: '',
    name: '',
    link: '',
    prefered_date: '',
    prefered_time: '',
    latlong: '',
    city: '',
    area: '',
    near_by: '',
    payment_mode: '',
    house_no: '',
    note: '',
    address: '',
    booking_status: 'confirmed',
    cost: '',
    total_price: '',
  });
  const [services, setServices] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [preferredTimeSlots, setPreferredTimeSlots] = React.useState([]);
  const [spareParts, setSparePartsData] = React.useState([]);
  const [items, setItem] = React.useState([]);
  const [assignedCar, setAssignedCar] = React.useState({ label: '', value: '' });
  /* eslint-disable */


  const getQuotationById = () => {
    setLoading(true);
   api
  .get(`/quotation/getQuotationById/${id}`)
 .then((res) => {
  const data = res.data.data;
  const assignedCarValue =
    typeof data?.assigned_car === 'object'
      ? data.assigned_car?.value || ''
      : data?.assigned_car || '';

  setQuotationData({
    ...data,

    // API → UI field-name mapping
    prefered_date: data?.prefered_date
      ? data.prefered_date.substring(0, 10)
      : '',

    prefered_time: data?.prefered_time || '',
    email: (data?.email && data?.email.includes('@') ? data?.email : '') || '',
    house_no: data?.house_no || (data?.email && !data?.email.includes('@') ? data?.email : '') || '',
  });
  setAssignedCar({
    label: data?.car_engine || data?.car_model || '',
    value: assignedCarValue,
  });


        class stdClass {
          constructor() {
            this.name = '';
            this.price = 0;
            this.per = 0;
            this.id = 0;
            this.total = 0;
            this.qty = 0;
          }
        }

        let sparePartsData = [];
        try {
          const parsed = unserialize(res.data.data?.spare_parts || 'a:0:{}', { stdClass });
          sparePartsData = Array.isArray(parsed) ? parsed : Object.values(parsed || {});
        } catch (parseErr) {
          console.error('Unable to read quotation spare parts', parseErr);
        }

        setSparePartsData(sparePartsData);
        const newSparePartsData = res.data.data?.spare_parts_new || [];
       const serviceItem = [...(res.data.data?.services || [])];
        /* eslint-disable */

        if (sparePartsData.length > 0) {
          sparePartsData.forEach((re) => {
            serviceItem.push({
              add_booking_name: re.name,
              add_booking_price:
                parseFloat(re.price || 0) +
                (parseFloat(re.per || 0) / 100) * parseFloat(re.price || 0),
              qty: re.qty,
              total: re.total,
              type: 'spare',
            });
          });
        }
        if (newSparePartsData.length > 0) {
          newSparePartsData.forEach((element) => {
            serviceItem.push({
              add_booking_name: element.sp_brand,
              add_booking_price: parseFloat(element.sp_price || 0),
              qty: element.sp_qty,
              total: parseFloat(element.sp_price || 0) * parseFloat(element.sp_qty || 1),
              type: 'spare',
            });
          });
        }

        setItem(serviceItem);
        /* eslint-enable */
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        toast.error('Unable to get Quote data');
        setLoading(false);
      });
  };
  const getQuotationServices = () => {
    api
      .get('/quotation/getServicesOfQuotation', { params: { id } })
      .then((res) => {
        setServices(res.data?.data || []);
      })
      .catch((err) => {
        console.error(err);
        setServices([]);
      });
  };
  // Quotation spares are stored on the quotation itself (quotations.spare_parts,
  // PHP-serialized), the same shape Add Quotation writes. Each change sends the
  // whole list with the new quotation total and cost.
  const spareLineCost = (spare) =>
    (parseFloat(spare.cost ?? spare.price) || 0) * (parseFloat(spare.qty) || 0);

  const saveQuotationSpares = (nextSpares, total, cost, successMessage) =>
    api
      .put(`/quotation/addSpare/${id}`, {
        spare_parts: serialize(nextSpares),
        total: Math.max(0, total).toFixed(2),
        cost: Math.max(0, cost).toFixed(2),
      })
      .then((response) => {
        if (!isApiSuccess(response)) throw new Error('Spare update was not saved');
        toast.success(successMessage);
        window.location.reload();
      });

  const addSpareParts = (spare) => {
    const newSpare = {
      name: spare.name || spare.brand || '',
      price: String(spare.price ?? '0'),
      cost: String(spare.cost ?? '0'),
      type: spare.type || 'spare',
      qty: String(spare.qty || '1'),
      percentage: String(spare.percentage ?? spare.per ?? '0'),
      per: String(spare.per ?? spare.percentage ?? '0'),
      total: String(spare.total ?? '0'),
      id: spare.id ?? spare.tyre_id ?? '',
    };
    saveQuotationSpares(
      [...(spareParts || []), newSpare],
      (parseFloat(quote?.total_price) || 0) + (parseFloat(newSpare.total) || 0),
      (parseFloat(quote?.cost) || 0) + spareLineCost(newSpare),
      'Spare added',
    ).catch((err) => {
      console.error(err);
      toast.error('Unable to add spare');
    });
  };
  /* eslint-enable */
  const gettimeslot = async () => {
    api
      .get('/location/time_zones')
      .then((res) => {
        setPreferredTimeSlots(res.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const handleChange = (event) => {
    if (event.target.name === 'phone') {
      event.target.value = event.target.value.replace(/[^a-zA-Z0-9 ]/g, '');
    }
    setQuotationData({ ...quote, [event.target.name]: event.target.value });
  };
  const handleLocationSelect = ({ city, area, latlong }) => {
    setQuotationData((current) => ({
      ...current,
      city,
      area,
      latlong,
    }));
  };
  React.useEffect(() => {
    getQuotationById();
    getQuotationServices();
    gettimeslot();
    return () => {
      getQuotationById();
      gettimeslot();
    };
  }, []);
  const deleteServicesFromBooking = (addService) => {
   showSwal({
  title: 'Are you sure?',
  text: "You won't be able to revert this!",
  icon: 'warning',
  showCancelButton: true,
  confirmButtonText: 'Yes, delete it!',
}, 'delete').then((result) => {
  if (result.isConfirmed) {
        addService.booking_id = id;
        addService.total_price =
          parseFloat(quote?.total_price) - parseFloat(addService.add_booking_price);
        api
          .delete(`/quotation/deleteServicesFromBooking/${addService.add_service_id}`, {
            data: {
              booking_id: id,
              total_price: parseFloat(quote?.total_price) - parseFloat(addService.add_booking_price),
            },
          })
          .then((response) => {
            if (isApiSuccess(response)) {
              window.location.reload();
            } else {
              toast.warning('Unable to delete Service');
            }
          })
          .catch((err) => {
            console.error(err);
            toast.error('Unable to delete Service');
          });
      }
    });
  };
  // Remove only the clicked row. Custom spares all share an empty id, so
  // filtering by id would drop every one of them.
  const handleDeleteSpareParts = (selectedObj) => {
    let index = spareParts.indexOf(selectedObj);
    if (index === -1) {
      index = spareParts.findIndex((item) => item.id === selectedObj.id
        && item.name === selectedObj.name
        && String(item.qty) === String(selectedObj.qty)
        && String(item.total) === String(selectedObj.total));
    }
    if (index === -1) {
      toast.error('Spare not found, reload the page and try again');
      return;
    }
    saveQuotationSpares(
      spareParts.filter((_, i) => i !== index),
      (parseFloat(quote?.total_price) || 0) - (parseFloat(selectedObj.total) || 0),
      (parseFloat(quote?.cost) || 0) - spareLineCost(selectedObj),
      'Spare removed',
    ).catch((err) => {
      console.error(err);
      toast.error('Unable to remove spare');
    });
  };
  const ondeleteSpare = (spare) => {
    handleDeleteSpareParts(spare);
  };
  const submitEditBooking = () => {
    let preferedDate = quote.prefered_date;
    if (quote.prefered_date.length === 10) {
      preferedDate = buildPreferredDate(
        quote.prefered_date,
        quote.prefered_time,
        preferredTimeSlots,
        utcOffset,
      );
    }
    if (quote.prefered_time === '' || quote.prefered_date === '' || quote.payment_mode === '') {
      toast.error('Please fill in all required booking details!');
    } else {
      setLoading(true);
      quote.prefered_date = preferedDate;
      const quotePayload = { ...(quote || {}) };
      delete quotePayload.id;
      api
        .put(`/quotation/updateQuotationById/${id}`, quotePayload)
        .then((res) => {
          if (isApiSuccess(res)) {
            setLoading(false);
            toast.success('Booking Edit Done');
            window.location.reload();
          } else {
            toast.warning('Unable to edit booking');
          }
        })
        .catch((err) => {
          console.error(err);
          toast.error('Network Connection error');
        });
    }
  };
  function reverseWords(s) {
    /* eslint-disable */
    let ans = '';
    const strArray = s.split(' ');
    s = s.replace('(', ' ').replace(')', ' ');

    for (var i = strArray.length - 1; i >= 0; i--) {
      ans += strArray[i] + ' ';
    }

    return ans;
  }

  const generateQuote = async () => {
    const serviceLines = (services || [])
      .filter((service) => service.type !== 'spare')
      .map((service) => {
        const details = [
          Number(service.is_addon) === 1 && service.parent_service_name ? `Add-on to ${service.parent_service_name}` : '',
          service.add_car_no ? `Plate: ${service.add_car_no}` : '',
        ].filter(Boolean);
        return {
          name: (service.add_booking_name || service.name || 'Car Care & Wash Service').split('/')[0].trim(),
          subtitle: details.join('   |   '),
          vehicle: formatVehicleType(firstPresent(service.add_car_type, service.car_type, quote?.car_type)),
          amount: parseFloat(service.add_booking_price || service.price || 0) || 0,
        };
      });

    const spareLines = items
      .filter((item) => item.type === 'spare')
      .map((spare) => {
        const qty = parseFloat(spare.qty) || 1;
        // `total` is the stored line amount (markup included), the same value
        // the spare table shows and the quotation total is built from.
        const storedTotal = parseFloat(spare.total);
        const amount = Number.isFinite(storedTotal)
          ? storedTotal
          : (parseFloat(spare.add_booking_price) || 0) * qty;
        return {
          name: String(spare.add_booking_name || 'Spare Part').split('/')[0].trim(),
          subtitle: `Spare part   |   Qty ${qty} x ${(amount / qty).toFixed(2)}`,
          vehicle: '-',
          amount,
        };
      });

    const timeSlot = preferredTimeSlots.find(
      (slot) => String(slot.id) === String(quote?.prefered_time),
    )?.time_zone;

    const name = String(quote?.name || '');
    try {
      await openBrandedPdf((logo) => buildQuotationPdf({
        quote,
        customerName: name.match(/[a-z]/i) ? name : reverseWords(name).trim(),
        lines: [...serviceLines, ...spareLines],
        timeSlot,
        // The services carry the vehicle type picked on the form; the
        // quotation's own car_type was always saved as 'salon', so it is only
        // a fallback. A quotation with both kinds lists both.
        vehicleType: [...new Set(
          (services || [])
            .map((service) => service.add_car_type)
            .filter((carType) => !isBlank(carType))
            .map(formatVehicleType),
        )].join(', ') || formatVehicleType(quote?.car_type),
        preparedBy: signedInUserName(),
        logo,
        currency: currencyCode,
        taxLineItems,
        getAmountWithTax,
        timezone,
      }));
    } catch (err) {
      console.error(err);
      toast.error('Unable to generate the quotation PDF. Allow pop-ups for this site and try again.');
    }
  };

  return (
    <>
      <div className="edit-booking-page-navigation">
        <BackButton />
        <div className="edit-booking-page-breadcrumbs">
          <BreadCrumbs />
        </div>
      </div>
      <div className="edit-quote-page">
      <ComponentCard>
        <AppButton
          onClick={() => {
            generateQuote();
          }}
          
          className="mb-3"
        >
          Generate Quote
        </AppButton>
       <SectionOne
  formData={quote}
  handleChange={handleChange}
  preferredTimeSlots={preferredTimeSlots}
  onLocationSelect={handleLocationSelect}
  onSubmit={submitEditBooking}
  loading={loading}
/>
      
        <hr></hr>
        <Text variant="cardTitle">Services</Text>
        <QuotationServices
          editQuotation
          quotationId={id}
          quotePrice={quote?.total_price}
          disabled={quote?.quote_status != '0'}
          toast={toast}
        />
        <DataTable
          className="mt-3"
          columns={[
            { key: 'number', header: 'S.No', render: (row, index) => index + 1 },
            // is_addon / category_name / parent_service_name / duration come
            // from getServicesOfQuotation, which resolves add-ons server-side:
            // main-service and add-on ids overlap, so a catalog lookup by id
            // alone mislabels rows.
            { key: 'category', header: 'Category', render: (row) => row.category_name || '--' },
            {
              key: 'service',
              header: 'Service',
              render: (row) => (Number(row.is_addon) === 1 ? row.parent_service_name || '--' : row.add_booking_name || '-'),
            },
            {
              key: 'additionalService',
              header: 'Additional Service',
              render: (row) => (Number(row.is_addon) === 1 ? row.add_booking_name || '--' : '--'),
            },
            {
              key: 'carType',
              header: 'Car Type',
              render: (row) => row.add_car_type || row.car_type || '-',
            },
            {
              key: 'carNo',
              header: 'Car No',
              render: (row) => row.add_car_no || row.car_no || '-',
            },
            {
              key: 'duration',
              header: 'Duration (Min)',
              render: (row) => row.duration ?? '-',
            },
            {
              key: 'price',
              header: 'Price (INR)',
              render: (row) => formatCurrency(row.add_booking_price || row.price || 0),
            },
            {
              key: 'action',
              header: 'Action',
              render: (row) => (
                <ActionButton
                  action="delete"
                  onClick={() => deleteServicesFromBooking(row)}
                  disabled={quote?.quote_status != '0'}
                />
              ),
            },
          ]}
          data={(services || []).filter((service) => service.type !== 'spare')}
          loading={loading}
          searchable={false}
          emptyMessage="No services found"
          rowKey={(row) => row.add_service_id || row.id}
        />
        <hr></hr>
        <Text variant="cardTitle">Spare</Text>
        {/* <EditSpare
          selectedSpare={spareParts}
          id={id}
          toast={toast}
          total={quote?.total_price}
          cost={quote?.cost}
          disabled={quote?.quote_status != '0'}
        ></EditSpare> */}
        <SpareAdd
          enforceStock={false}
          spareParts={spareParts}
          addSpareParts={addSpareParts}
          assigned_car={assignedCar}
          setAssignedCar={setAssignedCar}
          ondeleteSpare={ondeleteSpare}
          className="slot-booking-spare-parts"
          vehicleClassName="quotation-vehicle-info-reference"
        />
        <DataTable
          columns={[
            { key: 'name', header: 'Name' },
            { key: 'price', header: 'Price' },
            { key: 'qty', header: 'Qty' },
            { key: 'per', header: 'Percentage' },
            { key: 'total', header: 'Total' },
            ...taxLineItems.map((lineItem) => ({
              key: `tax-${lineItem.label}`,
              header: lineItem.label,
              render: (row) => Number(lineItem.rate || 0) * parseFloat(row.total),
            })),
            { key: 'withTax', header: `With ${taxMode}`, render: (row) => getAmountWithTax(row.total) },
            {
              key: 'action',
              header: 'Action',
              render: (row) => (
                <ActionButton
                  action="delete"
                  onClick={() => handleDeleteSpareParts(row)}
                  disabled={quote?.quote_status != '0'}
                />
              ),
            },
          ]}
          data={spareParts || []}
          loading={loading}
          searchable={false}
          emptyMessage="No spare parts found"
          rowKey={(row) => row.id}
        />
      </ComponentCard>
      </div>
    </>
  );
}
